import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './contexts/UserContext.js';
import { SecondHeaderProvider } from './contexts/SecondHeaderContext.js';
import { ThirdHeaderProvider } from './contexts/ThirdHeaderContext.js';
import { UnitDataCacheProvider } from './contexts/UnitDataCacheContext';
import { UnitDataParserProvider } from './contexts/UnitDataParserContext.js';
import './i18n';
import { InferenceRecordDataWorkerProvider } from './contexts/InferenceRecordData/InferenceRecordDataWorkerContext.js';
import { InferenceRecordDataParserProvider } from './contexts/InferenceRecordData/InferenceRecordDataParserContext.js';
import { LatestImageContextProvider } from './contexts/LatestImageContext.js';
import { LatestScreenshotContextProvider } from './contexts/LatestScreenshotContext.js';
import { RollOutProvider } from './contexts/RollOutContext';
import { ModelProvider } from './contexts/ModelContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

const purgeLegacyCaching = async () => {
    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            await Promise.all(registrations.map((registration) => registration.unregister()));
        }

        if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
        }
    } catch (error) {
        // Legacy cache cleanup should never block the app from starting.
        console.warn('Unable to clear legacy caching state', error);
    }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ThemeProvider theme={theme}>
        <UserProvider>
            <SecondHeaderProvider>
                <ThirdHeaderProvider>
                    <UnitDataCacheProvider>
                        <UnitDataParserProvider>
                            <InferenceRecordDataWorkerProvider>
                                <InferenceRecordDataParserProvider>
                                    <LatestImageContextProvider>
                                        <LatestScreenshotContextProvider>
                                            <RollOutProvider>
                                                <ModelProvider>
                                                    <App />
                                                </ModelProvider>
                                            </RollOutProvider>
                                        </LatestScreenshotContextProvider>
                                    </LatestImageContextProvider>
                                </InferenceRecordDataParserProvider>
                            </InferenceRecordDataWorkerProvider>
                        </UnitDataParserProvider>
                    </UnitDataCacheProvider>
                </ThirdHeaderProvider>
            </SecondHeaderProvider>
        </UserProvider>
    </ThemeProvider>
);

purgeLegacyCaching();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
